import { render, staticRenderFns } from "./StudentTable.vue?vue&type=template&id=41d6b89a"
import script from "./StudentTable.vue?vue&type=script&lang=js"
export * from "./StudentTable.vue?vue&type=script&lang=js"
import style0 from "./StudentTable.vue?vue&type=style&index=0&id=41d6b89a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports